import { css } from "@emotion/react"
import { Button } from "../Button"
import { AiOutlineFolder } from "react-icons/ai"
import { ChangeEvent, useRef } from "react"

type Props = {
  onChange?: (evt: ChangeEvent<HTMLInputElement>) => void
}
export const FileInputButton = (props: Props)=>{
  const inputElement = useRef<HTMLInputElement>(null)

  const onClick=()=>{
    if (inputElement.current != null) inputElement.current.click()
  }

  return(
    <>
      <Button onClick={onClick} level={'tertiaryContainer'}>
            <AiOutlineFolder/> ファイル選択
      </Button>
      <input 
        css={inputCss} 
        ref={inputElement} 
        type="file" 
        multiple
        onChange={props.onChange}
      />
    </>
  )
}

const inputCss=css`
  display:none;
`